import React from 'react';
import { useTranslation } from 'react-i18next';
import SEO from '../../components/common/SEO';
import { Link } from 'react-router-dom';


const JobApplicationCourse = () => {
  const { t } = useTranslation();

  return (
    <div className="py-12">
      <SEO 
        title={t('courses.job_application_course')} 
        description={t('courses.job_application_description')}
      />
      
      <div className="container mx-auto px-4 max-w-4xl">
        <article className="prose prose-lg max-w-none">
          <h1 className="text-4xl font-bold mb-6">
            {t('courses.job_application_course')}
          </h1>
          
        

          <h2>{t('common.courseDescription')}</h2>
          <p>
            {t('courses.job_application_full_description')}
          </p>

          <h2>{t('common.courseContent')}</h2>
          <ul>
            <li>{t('courses.job_application_content1')}</li>
            <li>{t('courses.job_application_content2')}</li>
            <li>{t('courses.job_application_content3')}</li>
            <li>{t('courses.job_application_content4')}</li>
          </ul>

          <div className="bg-gray-50 p-6 rounded-lg mt-8">
            <h3 className="text-xl font-bold mb-4">{t('common.courseDetails')}</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <p className="font-medium">{t('common.language')}:</p>
                <p>{t('languages.arabic_german')}</p>
              </div>
              <div>
                <p className="font-medium">{t('common.duration')}:</p>
                <p>{t('duration.3_hours')}</p>
              </div>
              <div>
                <p className="font-medium">{t('common.instructor')}:</p>
                <p>Dipl.-Ing Taher Doufesh</p>
              </div>
              <div>
                <p className="font-medium">{t('common.fee')}:</p>
                <p>{t('common.free')}</p>
              </div>
            </div>
          </div>

          <div className="mt-8">
            <Link
              to="/contact"
              className="bg-primary-600 text-white py-3 px-6 rounded-lg hover:bg-primary-700 transition-colors inline-block"
            >
              {t('courses.registerInterest')}
            </Link>
          </div>
        </article>
      </div>
    </div>
  );
};

export default JobApplicationCourse;